import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import DatePicker from "react-datepicker";
import moment from 'moment';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import {
	FormGroup,
	Label,
	
} from 'reactstrap';

import {
   getStudentDetails
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';



class studentDownloads extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         startdate:'',
         enddate:''
      };

      this.handleSubmit = this.handleSubmit.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.getStudentDetails("", "");
   }

   parseDate(dateString) {
      if (dateString.includes("st") || dateString.includes("nd") || dateString.includes("rd") || dateString.includes("th")) {
          const parts = dateString.split(' ');
          const day = parseInt(parts[0].replace(/\D/g,'')); 
          const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
          const month = monthNames.indexOf(parts[1]);
          const year = parseInt(parts[2]);
          return new Date(year, month, day);
      } else if (dateString.includes("-")) {
          const [year, month, day] = dateString.split("-");
          return new Date(year, month - 1, day);
      } else {
         //  console.error("Invalid date string:", dateString);
          return null;
      }
  }
  
   handleSubmit(event)
   {
      event.preventDefault();
      var startdate=this.state.startdate;
      var enddate=this.state.enddate;
      var start = moment(new Date(startdate)).format('YYYY-MM-DD');
      var end = moment(new Date(enddate)).format('YYYY-MM-DD');
      this.props.getStudentDetails(start, end);
   }

   selectdates = (date) => {
      this.setState({ startdate:date });     
   }

   selectdatee = (date) => {         
     this.setState({ enddate:date });
   }

   render() {
      const { match, studentdownloadlist, loading } = this.props;

      const sortedItems = studentdownloadlist.sort((a, b) => a.ctsa_agreement_start_date.localeCompare(b.ctsa_agreement_start_date));
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,         
         sortType: 'datetime', 
         customSort: (data, colIndex, order) => {
            return data.sort((a, b) => {
                const columnName = columns[colIndex].name;
                const value1 = columnName === "dob" ? this.parseDate(a.data[colIndex]) :
                               columnName === "stdate" || columnName === "eddate" ? this.parseDate(a.data[colIndex]) : a.data[colIndex];
                const value2 = columnName === "dob" ? this.parseDate(b.data[colIndex]) :
                               columnName === "stdate" || columnName === "eddate" ? this.parseDate(b.data[colIndex]) : b.data[colIndex];
                return order === 'asc' ? value1 - value2 : value2 - value1;
            });
        }
      };

   
      const columns = [
         { name: "no", label: "NO" },
         { name: "enrolmentid", label: "ENROLMENT ID" },
         {
            name: "Studentname", label: "STUDENT NAME", options: {
               customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
         { name: "email", label: "EMAIL",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "mobile", label: "MOBILE",
            options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } 
         },
         { name: "dob", label: "DATE OF BIRTH",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "bloodgroup", label: "BLOOD GROUP",
            options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
         { name: "foodpreference", label: "FOOD PREFERENCE",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "foodallergies", label: "FOOD ALLERGIES",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "madicalcondition", label: "MEDICAL CONDITION",
            options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } 
         },
         { name: "parentname", label: "PARENT NAME",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
         { name: "parentemail", label: "PARENT EMAIL",
            options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "parentmobile", label: "PARENT MOBILE",
            options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "address", label: "ADDRESS",
            options: {
               customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
         { name: "stdate", label: "AGREEMENT START DATE",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         { name: "eddate", label: "AGREEMENT END DATE",
         options: {
            customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            } },
         {
            name: "program", label: "PROGRAM", options: {
               customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
         {
            name: "programinclusion", label: "PROGRAM INCLUSIONS",
            options: {
               customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
            }
         },
      ];


      const tabledata = sortedItems.map((assmntval, idx) => {

         return {
            no: idx + 1,
            enrolmentid: assmntval.ctsa_enrollmentID,
            Studentname: assmntval.studentname,
            email: assmntval.uud_email,
            mobile: assmntval.uud_phone,
            dob: assmntval.uud_dob,
            bloodgroup: assmntval.ctsd_bloodgroup,
            foodpreference: assmntval.ctsd_food,
            foodallergies: assmntval.ctsd_foodallergies,
            madicalcondition: assmntval.ctsd_medical,
            parentname: assmntval.parentname,
            parentemail: assmntval.parentemail,
            parentmobile: assmntval.parentmobile,
            address: assmntval.uud_address,
            stdate: assmntval.stdate,
            eddate: assmntval.eddate,
            program: assmntval.program,
            programinclusion: assmntval.pgminclusion,
         };
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> Student Details Download| {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.studentdownload" />} match={match} />
            <div className="col-lg-8">             

                   <RctCollapsibleCard fullBlock>
                                           
                            <div className="row" style={{padding:"10px"}}>
                                <div className="col-lg-4">
                                        <FormGroup >
                                            <Label for="Email-3">Start Date </Label>
                                            <DatePicker className="form-control" id="startdate"  name="startdate" autoComplete="off" 
                                                    selected={this.state.startdate}
                                                    onChange={this.selectdates}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown 
                                                    
                                                /> 
                                        </FormGroup>                                          
                                </div>

                                    <div className="col-lg-4">
                                        <FormGroup >
                                            <Label for="Email-3">End Date </Label>
                                            <DatePicker className="form-control" id="enddate"  name="enddate" autoComplete="off" 
                                                    selected={this.state.enddate}
                                                    onChange={this.selectdatee}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                /> 
                                        </FormGroup>                                          
                                    </div> 
                                    
                                    <div className="form-group">                       
                                            <input type="submit" onClick={this.handleSubmit} className="mr-3 mb-3 btn btn-outline-primary" value="Submit" style={{marginTop:"20px"}}/>                                            
                                    </div>  
                                                        
                            </div>
                            
                    </RctCollapsibleCard>

                </div>
            {this.state.viewdiv &&
               
               <div className="col-sm-12 col-lg-12">
                  <RctCollapsibleCard heading="ALL Data" fullBlock>
                     <MUIDataTable
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }
         </div>
      )
   }
}

const mapStateToProps = ({ studentdownload }) => {
   const { studentdownloadlist, loading } = studentdownload;
   return { studentdownloadlist, loading };
}

export default connect(mapStateToProps, {
   getStudentDetails
})(studentDownloads); 